import "core-js/modules/es.array.concat.js";
import RichText from '~/components/ui/RichText.vue';
import AzImg from '~/components/Atoms/AzImg.vue';
export default defineComponent({
  name: 'ItemImageTextEnum',
  components: {
    RichText: RichText,
    AzImg: AzImg
  },
  props: {
    image: Object,
    text: Object,
    title: String,
    classes: {
      type: Object,
      default: function _default() {}
    }
  },
  setup: function setup(props) {
    var dimensions = computed(function () {
      var _props$image, _props$image$metadata, _props$image2, _props$image2$metadat;
      if ((_props$image = props.image) !== null && _props$image !== void 0 && (_props$image$metadata = _props$image.metadata) !== null && _props$image$metadata !== void 0 && _props$image$metadata.width && (_props$image2 = props.image) !== null && _props$image2 !== void 0 && (_props$image2$metadat = _props$image2.metadata) !== null && _props$image2$metadat !== void 0 && _props$image2$metadat.height) {
        return "".concat(props.image.metadata.width, "/").concat(props.image.metadata.height);
      }
    });
    return {
      dimensions: dimensions
    };
  }
});